module.exports = __webpack_public_path__ + "static/target-7c6e8f3f1929abf664ba3c19d44480c7.mp4";